import React from 'react';
import { Modal, Button } from 'react-bootstrap';

interface EditInventoryConfirmModalProps {
  show: boolean;
  onConfirm: () => void;
  onCancel: () => void;
}

export default function EditInventoryConfirmModal({
  show,
  onConfirm,
  onCancel,
}: EditInventoryConfirmModalProps): JSX.Element {
  return (
    <Modal show={show} onHide={onCancel} centered>
      <Modal.Header closeButton>
        <Modal.Title>Edit Finalized Inventory</Modal.Title>
      </Modal.Header>
      <Modal.Body>
        <p className="mb-2">
          This inventory run is already finalized. Are you sure you want to edit it?
        </p>
        <p className="text-muted mb-0">
          The recorded items can be changed, but the run dates will remain unchanged.
        </p>
      </Modal.Body>
      <Modal.Footer>
        <Button variant="secondary" onClick={onCancel}>
          Cancel
        </Button>
        <Button variant="warning" onClick={onConfirm}>
          Edit
        </Button>
      </Modal.Footer>
    </Modal>
  );
}

